import { UI_ROUTE_MOCKED, UI_ROUTES } from './routes';

const PAYOUTS_PATHS: string[] = [
  UI_ROUTES.payouts + UI_ROUTES.payoutsMethods,
  UI_ROUTES.payouts + UI_ROUTES.withdrawalAmount,
  UI_ROUTES.payouts + UI_ROUTES.withdrawCryptoAmount,
  UI_ROUTES.payouts + UI_ROUTES.addYourBankAccount,
  UI_ROUTES.payouts + UI_ROUTES.uploadBankStatement,
  UI_ROUTES.payouts + UI_ROUTES.addCryptoAddress,
];

const AUTH_PATHS: string[] = [
  UI_ROUTES.signUp,
  UI_ROUTES.authResult,
  UI_ROUTES.emailConfirm,
  UI_ROUTES.baseURL,
];

export type RouteMatches = {
  isPayoutsPath: boolean;
  isAuthPath: boolean;
  isBuyOrSellPath: boolean;
  isModifyPath: boolean;
  isAuthResultPath: boolean;
  isEnrollPhoneVerified: boolean;
  isEnrollPhoneVerification: boolean;
  isEnrollPhoneVerificationOtp: boolean;
  isDemoPlanActivationErrorPath: boolean;
  isPaymentPlanErrorPath: boolean;
  isPaymentMethodSelectionPath: boolean;
  isCryptoPaymentPath: boolean;
  isTradeHistoryPath: boolean;
  isPayoutHistoryPath: boolean;
  isSearchSymbolMobPath: boolean;
  isPaymentCancelPath: boolean;
  isPaymentSuccessPath: boolean;
  isProductsPath: boolean;
  isMockedPath: boolean;
  isEmailConfirmPath: boolean;
  isTradingViewPath: boolean;
  isErrorPath: boolean;
};

export const getRouteMatches = (pathname: string): RouteMatches => {
  const includes = (path: string) => pathname.includes(path);
  const equals = (path: string) => pathname === path;
  const startsWith = (path: string) => pathname.startsWith(path);

  return {
    isPayoutsPath: PAYOUTS_PATHS.includes(pathname),
    isAuthPath: AUTH_PATHS.includes(pathname),
    isBuyOrSellPath: includes(UI_ROUTES.buy) || includes(UI_ROUTES.sell),
    isModifyPath: includes(UI_ROUTES.modify),
    isAuthResultPath: equals(UI_ROUTES.authResult),
    isEnrollPhoneVerified: equals(UI_ROUTES.enrollPhoneVerified),
    isEnrollPhoneVerification: equals(UI_ROUTES.enrollPhoneVerification),
    isEnrollPhoneVerificationOtp: equals(UI_ROUTES.enrollPhoneVerificationOtp),
    isDemoPlanActivationErrorPath: equals(UI_ROUTES.demoAccountActivationError),
    isPaymentPlanErrorPath: equals(UI_ROUTES.paymentError),
    isPaymentMethodSelectionPath: equals(UI_ROUTES.paymentMethodSelection),
    isCryptoPaymentPath: equals(UI_ROUTES.cryptoPayment),
    isTradeHistoryPath: equals(UI_ROUTES.tradeHistory),
    isPayoutHistoryPath: equals(UI_ROUTES.payoutHistory),
    isSearchSymbolMobPath: equals(UI_ROUTES.searchSymbolsMob),
    isPaymentCancelPath: equals(UI_ROUTES.paymentCancel),
    isPaymentSuccessPath: equals(UI_ROUTES.paymentSuccess),
    isProductsPath: equals(UI_ROUTES.products),
    isMockedPath: includes(UI_ROUTE_MOCKED),
    isEmailConfirmPath: equals(UI_ROUTES.emailConfirm),
    isTradingViewPath: startsWith(UI_ROUTES.tradingView),
    isErrorPath: startsWith(UI_ROUTES.error),
  };
};
